import { useQuery } from "@apollo/client";
import { GET_HOLIDAY, GET_HOLIDAYS } from "@/graphql/holidays";
import { useSalonStore } from "@/lib/store/salon";
import type { HolidayFilters } from "../types";

export function useHolidayQuery(filters?: HolidayFilters) {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  return useQuery(GET_HOLIDAYS, {
    variables: {
      salonId: salonId ?? "",
      scope: filters?.scope,
      isActive: filters?.isActive ?? true,
      timeFilter: filters?.timeFilter,
    },
    skip: !salonId,
    errorPolicy: "all",
    notifyOnNetworkStatusChange: true,
  });
}

export function useHolidayByIdQuery(holidayId?: string) {
  return useQuery(GET_HOLIDAY, {
    variables: { holidayId: holidayId ?? "" },
    skip: !holidayId,
    errorPolicy: "all",
  });
}
